import { render, staticRenderFns } from "./RouterLinkTo.vue?vue&type=template&id=2f3ff183&"
import script from "./RouterLinkTo.vue?vue&type=script&lang=js&"
export * from "./RouterLinkTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports